"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SAPRequestForFeedback = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.SAPRequestForFeedback = typebox_1.Type.Object({
    first_name: typebox_1.Type.String(),
});
//# sourceMappingURL=sap-request-for-feedback.js.map